// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"08f2c47c","703":"2fef186b"}[chunkId] + ".chunk.js";
};